const symbols = {
  goTop: require('raw!./align-top.svg'),
  goBottom: require('raw!./align-bottom.svg'),
  goBack: require('raw!./arrow-long-up.svg'),
  goForth: require('raw!./arrow-long-down.svg'),
  reverse: require('raw!./cycle.svg'),
  close: require('raw!./squared-cross.svg'),
  info: require('raw!./info-with-circle.svg')
}

riot.tag2('entypo-svg', '', '', 'class="entypo-svg"', function(opts) {

  this.updateContent = () => {
    this.root.innerHTML = symbols[this.opts.symbol]
  }

  this.on('update', () => {
    this.updateContent()
  })

  this.updateContent()
});



// WEBPACK FOOTER //
// ./src/components/entypo/entypo-svg.tag